import script from "./HomeComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeComponent.vue?vue&type=style&index=0&id=40c31e8e&lang=css"

const __exports__ = script;

export default __exports__